<mat-nav-list class="main-nav">
  <a mat-list-item id="{{nav.id}}" routerLink="{{nav.routeToLoad}}" routerLinkActive="" *ngFor="let nav of sidebarService.getNav()"> {{ nav.title }} </a>
</mat-nav-list>

<div *ngIf="sidebarService.displayEmailPref">
  <button mat-button class="button-like-nav" (click)="sidebarService.onEmailPref()">Email Preferences ({{sidebarService.protestInfo?.casedocket_email_preferences}})</button>
</div>

<div *ngIf="sidebarService.displayAdditionalNavs">
  <div *ngIf="sidebarService.addNavTitle">
    <br>
    <div class="pad-text"><b>{{sidebarService.addNavTitle}}</b></div>
    <div class="separator color_secondary"></div>
  </div>
  <mat-nav-list class="add-nav">
    <a mat-list-item id="{{nav.id}}" routerLink="{{nav.routeToLoad}}" routerLinkActive="" *ngFor="let nav of sidebarService.getAdditionalNav()"> {{ nav.title }} </a>
  </mat-nav-list>
</div>

<div *ngIf="sidebarService.completeButtonText != CaseCompleteState.NONE">
  <button mat-button class="button-like-nav" (click)="sidebarService.onComplete(sidebarService.completeButtonText)">{{sidebarService.completeButtonText}}</button>
</div>

